import $ from "jquery";
import "slick-carousel";
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class Carousels {
	constructor(){
		this.carousel = {
			hero: document.getElementById('fullscreen-carousel'),
			product: document.getElementById('product-carousel'),
            single: document.querySelector('.carousel[data-carousel="single"]'),
            variable_width: document.querySelector('.carousel[data-carousel="variable-width"]'),
		};
	}

	init() {
		if(this.carousel.hero) { this.fullscreen(); }
		if(this.carousel.product) { this.product(); }

        if(this.carousel.single) { this.singleItem(); }
        if(this.carousel.variable_width) { this.variableItems(); }
	}

	fullscreen = () => {
		const titles = $('.page-title .title');
		const carousel = $('#fullscreen-carousel');
		const thumbnails = $('#thumbnail-carousel');

		carousel.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			asNavFor: thumbnails,
		});

		thumbnails.not('.slick-initialized').slick(
			{
				dots: false,
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: false,
				autoplay: true,
				autoplaySpeed: 1500,
				rewind: true,
				mobileFirst: true,
				asNavFor: carousel,
			}
		)
		.on({
			init: function() {
				const titles = $('.page-title .title a');
				const current = $('.slick-current .item');
				titles.text(current.data('title'));
				titles.attr('href',current.data('project'));
			},
			beforeChange: function(event, slick, currentSlide, nextSlide, prevSlide) {
				const titles = $('.page-title .title a');
				const current = $('.slick-current .item');
				titles.text(current.data('title'));
				titles.attr('href',current.data('project'));
				carousel.slick('slickGoTo',prevSlide);
			},
			beforeChange: function(event, slick, currentSlide, nextSlide, prevSlide) {
				const titles = $('.page-title .title a');
				const current = $('.slick-current .item');
				titles.text(current.data('title'));
				titles.attr('href',current.data('project'));
			}
		});

		this.progress();
	}

	product = () => {
		const carousel = $('#product-carousel');

		if(carousel.data('items') > 1){
			carousel.slick({
				autoplay: true,
				autoplaySpeed: 3000,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				fade: true,
			});
		}
	}

	progress = () => {
		const titles = $('.page-title .title a');
		const current = $('.slick-current');

		var time = 1.5;
		var progressbar,
		slick = $('#thumbnail-carousel'),
		isPause,
		tick,
		percentTime;
		// percentOffset;

		progressbar = $('.progress');

		slick.on({
			mouseenter: function() {
				isPause = true;
				slick.slick('slickPause');
			},
			mouseleave: function() {
				isPause = false;
				slick.slick('slickPlay');
			},
			swipe: function() {
				startProgressbar();
			},
			beforeChange: function(){
				startProgressbar();
			}
		});

		titles.on({
			mouseenter: function() {
				isPause = true;
				slick.slick('slickPause');
				slick.find('.slick-current').addClass('hovering');
			},
			mouseleave: function() {
				isPause = false;
				slick.slick('slickPlay');
				slick.find('.slick-current').removeClass('hovering');
			}
		});

		function startProgressbar() {
			resetProgressbar();
			percentTime = 0;
			isPause = false;
			tick = setInterval(interval, 10);
		}

		function interval() {
			if(isPause === false) {
				percentTime += 1 / (time + 0.1);
				progressbar.css({
					height: 'calc('+ percentTime +'%)'
				});
				if(percentTime >= 100)
				{
					// slick.slick('slickNext');
					startProgressbar();
				}
			}
		}

		function resetProgressbar() {
			progressbar.css({
				height: 'calc('+ 0 +'%)'
			});
			clearTimeout(tick);
		}

		startProgressbar();
	}

    // CAROUSEL: Single Item
    singleItem = () => {
		const carousel = $('.carousel[data-carousel="single"]');

			carousel.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				fade: true,
                infinite: false,
				autoplay: true,
				autoplaySpeed: 1500,
				rewind: true,
				mobileFirst: true,
			});
	}

    // CAROUSEL: Variable Width
    variableItems = () => {
		const carousel = $('.carousel[data-carousel="variable-width"]');

			carousel.slick({
				slidesToShow: 1,
                slidesToScroll: 1,
				arrows: false,
                infinite: true,
				autoplay: true,
				autoplaySpeed: 1500,
				mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 414, 
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        }
                    }
                ],
			});
	}
}
